import magic from '../lib/magic'; // Use the frontend Magic SDK

export const generateImage = async (prompt) => {
  try {
    console.log('🎨 Starting image generation with prompt:', prompt);
    
    const didToken = await magic.user.getIdToken();
    const response = await fetch('/api/generate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${didToken}`
      },
      body: JSON.stringify({ prompt })
    });
    
    console.log('📡 Response status:', response.status);
    
    if (!response.ok) {
      const errorData = await response.json();
      console.error('❌ API error:', errorData);
      throw new Error(errorData.error || 'Failed to generate image');
    }

    const data = await response.json();
    console.log('📦 Response data:', data);

    // Check if we have images in the response
    if (!data.data || !data.data.length) {
      throw new Error('No image generated');
    }

    const imageUrl = data.data[0].url;
    const generatedPrompt = data.data[0].prompt;
    console.log('✅ Image URL:', imageUrl);
    
    return {
      url: imageUrl,
      prompt: generatedPrompt,
      timestamp: new Date().toISOString()
    };
  } catch (error) {
    console.error('❌ Error generating image:', error);
    error.isGenerationError = true;
    throw error;
  }
}; 